export const ROWS = 6;
export const COLS = 7;

export const PLAYER_COLORS = ['#f44336', '#fdd835']; // Red, Yellow

export function createEmptyBoard() {
    return Array.from({ length: ROWS }, () => Array(COLS).fill(null));
}

export function findLowestEmptyRow(board, col) {
    for (let r = ROWS - 1; r >= 0; r--) {
        if (board[r][col] === null) return r;
    }
    return -1;
}
